import { Button } from 'antd';
import React from 'react';

import { PmsEmpty } from 'common/components/svgs';

export default function EmptyPage({ t, setVisible }) {
  return (
    <div className="empty-container">
      <PmsEmpty />
      <p className="desc">{t('cms.pms_integrations.empty.desc')}</p>
      <Button onClick={setVisible} type="primary" icon="plus" className="add-btn">
        {t('cms.pms_integrations.empty.add_btn')}
      </Button>
    </div>
  );
}
